module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), (_vm.formStep == 0) ? _c('div', {
    staticClass: "form-container-adhesion"
  }, [_c('form-vehicle', {
    attrs: {
      "plate": _vm.plate,
      "ArrayVehicles": _vm.ArrayVehicles
    },
    on: {
      "ValueChanger": _vm.ChangeByPropsStepOne,
      "TurnOnLoading": _vm.ChangeLoadingStatusToOn,
      "TurnOffLoading": _vm.ChangeLoadingStatusToOff,
      "SaveVehicle": _vm.add,
      "AxesChanger": _vm.ChangeAxesInfo,
      "ModelChanger": _vm.ChangeModelInfo,
      "ValueChangerNetrinOff": _vm.ChangeByPropsStepOneNetrinOff,
      "TransportadorChanger": _vm.ChangeTransportadorInfo
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formStep == 1) ? _c('div', {
    staticClass: "form-container-adhesion"
  }, [(_vm.formStep == 1) ? _c('form-add-vehicles', {
    attrs: {
      "ArrayVehicles": _vm.vehicles,
      "formVisibility": _vm.formVisibility
    },
    on: {
      "stepBack": _vm.stepBackZero,
      "OpenForm": _vm.OpenForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formVisibility) ? _c('form-vehicle', {
    attrs: {
      "plate": _vm.plate,
      "ArrayVehicles": _vm.vehicles
    },
    on: {
      "ValueChanger": _vm.ChangeByPropsStepOne,
      "TurnOnLoading": _vm.ChangeLoadingStatusToOn,
      "TurnOffLoading": _vm.ChangeLoadingStatusToOff,
      "SaveVehicle": _vm.add,
      "AxesChanger": _vm.ChangeAxesInfo,
      "ModelChanger": _vm.ChangeModelInfo,
      "ValueChangerNetrinOff": _vm.ChangeByPropsStepOneNetrinOff,
      "TransportadorChanger": _vm.ChangeTransportadorInfo
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showModalInvalidPlate) ? _c('modal-simple', {
    on: {
      "close": function($event) {
        _vm.showModalInvalidPlate = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        ATENÇÃO!\n    ")]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("\n      Placa inválida."), _c('br'), _vm._v("Verifique se digitou a\n      placa correta.\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loadingV2') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-form"
    }
  }, [_c('h2', [_vm._v("Veículo(s) do plano")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-925108f4!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/vehicles.vue
// module id = 2191
// module chunks = 1